import { getTrackingHeadersMap } from "./getTrackingHeaders";
import axios from "./httpClient";

import { ApiType } from "./Types";
import { getUrl } from "./getURL";
import { ErrorMessages } from "../constants";
import { IMisdeliveryInvestigation } from "../models";
import { throwApiError } from "./apiError";
import { getHeaderActionType } from "../helpers";

/**
 * CRETE API call using Axios
 * @returns - Save and submit Investigation api and return same object
 */

export const SaveOrCompleteMSDInvestigation = async (params: IMisdeliveryInvestigation, osdNumber: number, action: "save" | "complete" = "save") => {
  try {
    // Get static headers from map (do not use || {})
    const staticHeaders = getTrackingHeadersMap(ApiType.MSD_IVESTIGATION);
    // Add dynamic values
    const headers = {
      ...staticHeaders,
      "OSD-Action-Type": getHeaderActionType(action),
      "OSD-Exception-Number": osdNumber?.toString(),
      "OSD-Exception-Type": "MSD",
    };
    const response = await axios.post(`${getUrl(ApiType.MSD_IVESTIGATION)}/${osdNumber}/investigation/${action}`, params, { headers });
    return response.data;
  } catch (error: any) {
    throwApiError(error, ErrorMessages.saveOrSubmitAPIError, { badRequestOrder: "errorsFirst" });
  }
};
